export default "__VITE_ASSET__35819201__"